const getOptionData = data => {
	const option = data && data.element ? data.element : null;

	return {
		callingCode: option ? option.dataset.callingCode || '' : '',
		countryCode: option ? option.dataset.countryCode || '' : '',
		countryName: option ? option.dataset.countryName || '' : '',
	};
};

const formatSelection = data => {
	const { countryCode, callingCode } = getOptionData( data );

	return countryCode && callingCode ? `${ countryCode } ${ callingCode }` : data.text;
};

const formatResult = data => {
	const { countryCode, callingCode, countryName } = getOptionData( data );

	if ( !countryCode || !callingCode ) {
		return data.text;
	}

	return countryName ? `${ countryName } · ${ countryCode } ${ callingCode }` : `${ countryCode } ${ callingCode }`;
};

const matchCountry = ( params, data ) => {
	const term = String( params.term || '' ).trim().toLocaleLowerCase();

	if ( !term ) {
		return data;
	}

	const { countryCode, callingCode, countryName } = getOptionData( data );
	const searchText = `${ countryName } ${ countryCode } ${ callingCode }`.toLocaleLowerCase();

	return searchText.includes( term ) ? data : null;
};

export function initPhoneCountrySelects() {
	const $ = window.jQuery;

	if ( !$ || !$.fn || typeof $.fn.selectWoo !== 'function' ) {
		return;
	}

	$( '.js-phone-country-code' ).each( function () {
		const select = $( this );

		if ( select.hasClass( 'select2-hidden-accessible' ) ) {
			return;
		}

		select.selectWoo( {
			dropdownCssClass: 'phone-country-dropdown',
			matcher: matchCountry,
			minimumResultsForSearch: 0,
			templateResult: formatResult,
			templateSelection: formatSelection,
			width: 'auto',
		} );
	} );

	$( document.body )
		.off( 'updated_checkout.phoneCountrySelect' )
		.on( 'updated_checkout.phoneCountrySelect', initPhoneCountrySelects );
}
